<template>
  <div>
    <h4 class="marginl10">
      待处理案件管理
    </h4>
    
    <!-- ========== 优化后的筛选区域 ========== -->
    <div class="filter-container">
      <!-- 第一行：出险时间筛选 -->
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">出险起始时间：</label>
          <el-date-picker
            @change="sttime()"
            v-model="st_time"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker">
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">出险结束时间：</label>
          <el-date-picker
            @change="entime()"
            v-model="en_time"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker">
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">保单号：</label>
          <el-input
            v-model="victimPolicyNo"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">出险人：</label>
          <el-input
            v-model="victimUser"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
      </div>
      
      <!-- 第二行：报案时间筛选 -->
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">报案起始时间：</label>
          <el-date-picker
            @change="sttime1()"
            v-model="st_time1"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker">
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">报案结束时间：</label>
          <el-date-picker
            @change="entime1()"
            v-model="en_time1"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker">
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">案件号查询：</label>
          <el-input
            v-model="caseNo"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">报案人手机号：</label>
          <el-input
            v-model="victimMobile"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
      </div>
      
      <!-- 第三行：其他筛选条件 -->
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">证件信息：</label>
          <el-input
            v-model="victimNational"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">服务类型筛选：</label>
          <el-select v-model="newContractType" clearable placeholder="请选择" class="filter-select">
            <el-option label="大包服务" value="1"></el-option>
            <el-option label="小包服务" value="2"></el-option>
            <el-option label="纯服务" value="3"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">保险公司：</label>
          <el-select
            clearable
            v-model="insuranceCompanyId"
            @change="suoshuFun"
            placeholder="请选择保险公司"
            filterable
            class="filter-select">
            <el-option
              v-if="item.insti.name"
              v-for="item in companies"
              :key="item.id"
              :label="item.insti.name"
              :value="item.insti.id">
            </el-option>
          </el-select>
        </div>
        <div class="filter-item" v-if="companies1.length != 0 && insuranceCompanyId != ''">
          <label class="filter-label">保险公司子公司：</label>
          <el-select
            clearable
            v-model="subRegulatorId"
            placeholder="请选择保险公司"
            filterable
            class="filter-select">
            <el-option
              v-for="item in companies1"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      
      <!-- 第四行：案件类型和医院名称 -->
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">案件类型筛选：</label>
          <el-select v-model="rescueType" clearable placeholder="请选择类型" filterable class="filter-select">
            <el-option label="救援" value="100"></el-option>
            <el-option label="救助" value="200"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">子类型：</label>
          <el-select v-model="subIncidentType" clearable placeholder="请选择类型" filterable class="filter-select">
            <el-option label="传统救援救助" value="100"></el-option>
            <el-option label="优先救援服务" value="200"></el-option>
            <el-option label="星使服务" value="300"></el-option>
            <el-option label="医疗垫付服务" value="400"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">医院名称：</label>
          <el-input
            v-model="hospitalName"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
      </div>
      
      <!-- 按钮区域 -->
      <div class="button-row">
        <div class="button-group">
          <el-button type="primary" plain @click="filt()" class="filter-btn">
            查询
          </el-button>
          <el-button type="primary" @click="Reset()" class="reset-btn">
            重置
          </el-button>
          <el-button type="primary" @click="caseexport()" class="export-btn">
            导出结果数据
          </el-button>
        </div>
      </div>
    </div>
    <!-- ========== 优化后的筛选区域结束 ========== -->
    
    <div style="margin-top: 15px" class="form_box">
      <el-table empty-text="暂无数据" :data="tableData" border>
        <el-table-column prop="number" label="序号" min-width="50%">
      </el-table-column>
      <!-- <el-table-column label="星标案件" min-width="60%">
        <template slot-scope="scope" >
          <div style="text-align: center;">
            <img style="width: 30px;" v-if="scope.row.obj.specialState == null || scope.row.obj.specialState == 2" @click="tinyspot(1,scope.row.obj.id)" src=".././images/xx1.png" alt="" />
            <img style="width: 30px;" v-if="scope.row.obj.specialState == 1" @click="tinyspot(2,scope.row.obj.id)" src=".././images/xx2.png" alt=""/>
            </div>
        </template>
      </el-table-column> -->
     
        <!-- <el-table-column  label="案件编号" min-width="80">
          <template slot-scope="scope">
            {{scope.row.casenumber}}({{scope.row.regulatorId}})
          </template>
        </el-table-column> -->
        <el-table-column prop="username" label="出险人姓名" min-width="50%">
        </el-table-column>
        <el-table-column prop="phone" label="报案人电话" min-width="70%">
        </el-table-column>
        <el-table-column prop="papers" label="证件信息" min-width="70%">
        </el-table-column>
        <el-table-column prop="rescueType" label="主类型" min-width="70%">
          <template slot-scope="scope">
            <span v-if="scope.row.rescueType == 100">救援</span>
            <span v-if="scope.row.rescueType == 200">救助</span>
          </template>
        </el-table-column>
       
        <el-table-column prop="subIncidentType" label="子类型" min-width="70%">
          <template slot-scope="scope">
            <span v-if="scope.row.subIncidentType == 100">传统救援救助</span>
            <span v-if="scope.row.subIncidentType == 200">优先救援服务</span>
            <span v-if="scope.row.subIncidentType == 300">星使服务</span>
            <span v-if="scope.row.subIncidentType == 400">医疗垫付服务</span>
          </template>
        </el-table-column>
        <el-table-column prop="insurancePolicyNo" label="保单号" min-width="50%">
        </el-table-column>
        <el-table-column prop="casenumber" label="客户案件号" min-width="70%">
        </el-table-column>
        <el-table-column
          prop="subRegulatorIdname"
          label="保险公司子公司"
          min-width="80%"
        >
        </el-table-column>
        <el-table-column
          label="服务类型"
          min-width="80%"
        >
        <template slot-scope="scope">
          <span v-if="scope.row.newContractType == 1">大包服务</span>
          <span v-if="scope.row.newContractType == 2">小包服务</span>
          <span v-if="scope.row.newContractType == 3">纯服务</span>
          </template>
        </el-table-column>
        <el-table-column prop="hospitalName" label="医院名称" min-width="90%">
        </el-table-column>
        <el-table-column prop="time" label="出险时间" min-width="90%">
        </el-table-column>
        <el-table-column prop="reportTs" label="报案时间" min-width="90%">
        </el-table-column>
        <el-table-column prop="plan" label="当前进度" min-width="80%">
        </el-table-column>
        
        <el-table-column prop="op" label="操作" min-width="100%">
          <template slot-scope="scope">
            <!-- <div v-if="creatTime(scope.row.obj.stateText4) != undefined">
              <div v-if="scope.row.countdown" v-text="'倒计时：' + creatTime(scope.row.obj.stateText4)"></div> 
            </div> -->
            <!-- <div>
              <el-button
              type="text"
              size="small"
              v-if="scope.row.state == 100"
              @click="topathDetail(scope.$index, scope.row)"
              >启动救援</el-button
            >
            </div> -->
            <div>
              <el-button
              type="text"
              size="small"
              @click="topar(scope.row.initialCaseId,scope.row)"
              >救援详情</el-button
            >
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="op" label="操作" min-width="90%">
        <template slot-scope="scope">
      
          <el-button  v-if="scope.row.mailTime == null || scope.row.mailTime == ''" :disabled="scope.row.plan == '案件已关闭'" type="text" size="small"  @click="tostatr(scope.row)">发邮件给保险公司</el-button>
      
           <el-button v-else type="text" size="small" style="color:#666">已发送邮件</el-button>
          <el-button type="text" size="small" @click="topar(scope.row.initialCaseId)">案件详情</el-button>
        </template>
      </el-table-column> -->
      </el-table>
      <el-pagination
        style="margin-top: 15px; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[10,20,30,40,50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确认关闭？</span>
      <textarea placeholder="请输入关闭原因" v-model="closeTxt" class="closeTxt"></textarea>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;closeCase(closeId)">确 定</el-button>
      </span>
    </el-dialog> -->
    </div>
    <!-- 弹窗 -->
    <el-dialog
      title="确认完成案件"
      center
      :visible.sync="dialogFormVisible"
      width="800px"
    >
      <div class="popBox">
        <p style="margin-bottom: 15px">救援费用:</p>
        <ul>
          <li>
            <span>救援费用</span>
            <el-input type="text" v-model="rescueFee"></el-input>
            <span>RMB</span>
          </li>
          <li>
            <span>医疗费用</span>
            <el-input type="text" v-model="medicFee"></el-input>
            <span>RMB</span>
          </li>
          <li>
            <span>其他费用</span>
            <el-input type="text" v-model="otherFee"></el-input>
            <span>RMB</span>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureFun()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog
      title="修改协调人"
      :visible.sync="showcooperaterDialogVisible"
      center
      top="1vh"
      width="1000px"
      @close="toggleSelection()"
    >
      <span
        class="contactAddStyle"
        @click="addContacterDialogVisible = true"
      ></span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="修改协调人" name="second">
          <el-table
            empty-text="暂无数据"
            :data="cooperaterData"
            class="mgt15"
            border
            @selection-change="handleSelectionChange"
            ref="multipleTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="mobileNo"
              label="手机号"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="nationalId"
              label="证件号码"
              min-width="30"
            ></el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px">
            <el-button type="primary" @click="diffDomestic()">确定</el-button>
            <el-button
              @click="
                toggleSelection();
                showcooperaterDialogVisible = false;
              "
              >取消</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="非公司隶属的协调人" name="first">
          <el-table
            empty-text="暂无数据"
            :data="cooperaterData1"
            class="mgt15"
            border
            @selection-change="handleSelectionChange1"
            ref="multipleTable1"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="mobileNo"
              label="手机号"
              min-width="30"
            ></el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px">
            <el-button type="primary" @click="diffNormalUser()">确定</el-button>
            <el-button
              @click="
                toggleSelection1();
                showcooperaterDialogVisible = false;
              "
              >取消</el-button
            >
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog
      title="关闭案件说明"
      center
      :visible.sync="dialogFormVisible1"
      width="500px"
    >
      <!-- <center>是否确认关闭？</center> -->
      <el-input type="text"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="closeCase()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加新注册的协调人 -->
    <el-dialog
      title="添加新协调人"
      center
      :visible.sync="addContacterDialogVisible"
      width="500px"
    >
      <div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input
            v-model="victimName"
            placeholder="请输入姓名"
            style="width: 300px"
          ></el-input>
        </div>
        <div style="margin-top: 10px">
          手机号：<el-input
            v-model="nationalMobile"
            placeholder="请输入姓名"
            style="width: 300px"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addContacterDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="newDJXid()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import "isomorphic-fetch";
import {
  usersendCaseMail,
  listSubRegulators,
  userlist_regulator,
  getfinishSureCase,
  listSubUser,
  diffDomestic,
  listDomestic,
  removeDomestic,
  closeCase,
  listNormalUser,
  diffNormalUser,
  creatBasic,
  joinCoord,
  export_caseManage_List,
  casespecialCaseState
} from "@/views/axios/api.js";
import constants from "@/util/constants.js";
export default {
  data() {
    
    // 未启动
    // status: 100

    // 已启动
    // status: 120
    // status: 130
    // status: 140
    // status: 150
    // status: 160
    // status: 180

    // 救援完成待确认
    // status: 190

    // 已完成
    // status: 110
    // status: 111
    // status: 113
    return {
      subIncidentType:'',
      rescueType:'',
      state:'',
      minute:0,
      second:0,
      Remainder:null,
      countdown:true,
      itemcaseID: "",
      sta: "全部",
      start: 0,
      count: 10,
      total: 0,
      currentPage4: 1,
      victimUser: "",
      victimMobile: "",
      hospitalName:"",
      jtOrderId:'',
      caseNo: "",
      victimPolicyNo: "",
      victimNational: "",
      miniPolicy:"",
      accidentTypes: [
        "疏通马桶服务",
        "开锁服务",
        "油烟机清洗",
        "油烟机拆洗",
        "保洁2小时",
        "保洁4小时",
        "擦玻璃小户型（100平米下）",
        "擦玻璃大户型（100-150平米）",
      ],
      newContractType: "",
      reportUser: "",
      st_time: "",
      en_time: "",
      st_time1: "",
      en_time1: "",
      subRegulatorId: "",
      companies1: [],
      companies: [],
      insuranceCompanyId: "",
      closeId: "",
      closeTxt: "",
      obj: [],
      victimList: [],
      tableData: [],
      token: JSON.parse(window.localStorage.getItem("data")).data,
      dialogFormVisible: false,
      totalFee: "",
      rescueFee: "",
      medicFee: "",
      otherFee: 0,
      caseId: "",
      userType: JSON.parse(window.localStorage.getItem("insti")).type,
      showcooperaterDialogVisible: false, //添加
      cooperaterData: [], //所有联系人
      cooperaterData1: [], //所有联系人
      cooperaterDataList: [], //当前案件未修改之前的记录
      cooperaterDataListCheck: [], //当前案件修改之后
      dialogFormVisible1: false,
      statusObj: ["在保", "无保", "在保", "旅责险"],
      activeName: "second",
      tabBtn: true,
      ruserDataListCheck: [],
      addContacterDialogVisible: false,
      victimName: "",
      nationalMobile: "",
      ticker: null
    };
  },
  computed:{ //这里是监听自定义数组的变化 因为有一个计时器每秒都会减去数组中字段的时间 所以 数组是每秒更新的
    iconlistall:{
        get(){
            return this.tableData
        }
    },
    languageIndex(){
				return this.$store.state.language
			}
  },	
  methods: {
    tinyspot(type,id) {
       var obj = {
        caseId:id,
        state:type,
        token: this.token
       }
       casespecialCaseState(obj).then((res)=>{
        this.getData()
        console.log(res)
       })
    },
    Exportrecords() {
        this.$router.push({
					name:'Exportrecords',
          query: {
                typeId: 800
              },
				})
      },

    handleSizeChange(val) {
      this.count = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.start = (val - 1) * this.count;
      // this.start = val * 10
      this.getData();
      console.log(`当前页: ${val}`);
    },
    caseexport() {
      if(this.subIncidentType == '' || this.subIncidentType == null || this.subIncidentType == undefined) {
        this.$message.error("请选择案件类型子类型");
        return;
      }
      var statustxt = "";
      if (this.sta == "全部") {
        statustxt =
          statustxt +
          `&status=180`;
      } else {
        statustxt = this.sta;
      }
       if(this.st_time == null) {
        this.st_time = ''
       }
       if(this.en_time == '' || this.en_time == null ) {
        this.en_time =''
       }else{
        this.en_time = this.en_time + 24 * 60 * 60 * 1000 - 1
       }
       if(this.st_time1 == null) {
        this.st_time1 = ''
       }
       if(this.en_time1 == '' || this.en_time1 == null ) {
        this.en_time1 =''
       }else{
        this.en_time1 = this.en_time1 + 24 * 60 * 60 * 1000 - 1
       }
       
       var obj = {
        token:JSON.parse(window.localStorage.getItem("data")).data,
        incidentType:900,
        startTs:this.st_time,
        endTs:this.en_time,
        incidentStartTs:this.st_time1,
        incidentEndTs:this.en_time1,
        regulatorId:this.insuranceCompanyId,
        subRegulatorId:this.subRegulatorId,
        reportUser:this.reportUser,
        newContractType:this.newContractType,
        victimUser:this.victimUser,
        victimPolicyNo:this.victimPolicyNo,
        victimNational:this.victimNational,
        subIncidentType:this.subIncidentType,
        rescueType:this.rescueType,
        miniPolicy:this.miniPolicy,
        reporterContact:this.victimMobile,
        hospitalName:this.hospitalName,
        jtOrderId:this.jtOrderId,
        caseNo:this.caseNo,
        statustxt:statustxt
       }
       console.log(obj)
      //  return
      window.location.href =`${SEVSRS}/rescue/case/export_newcase_list?token=${JSON.parse(window.localStorage.getItem("data")).data}&incidentType=900&startTs=${this.st_time1}&endTs=${this.en_time1}&incidentStartTs=${this.st_time}&incidentEndTs=${this.en_time}&regulatorId=${this.insuranceCompanyId}&subRegulatorId=${this.subRegulatorId}&reportUser=${this.reportUser}&newContractType=${this.newContractType}&victimUser=${this.victimUser}&victimPolicyNo=${this.victimPolicyNo}&victimNational=${this.victimNational}&rescueType=${this.rescueType}&miniPolicy=${this.miniPolicy}&hospitalName=${this.hospitalName}&jtOrderId=${this.jtOrderId}&reporterContact=${this.victimMobile}&caseNo=${this.caseNo}&subIncidentType=${this.subIncidentType}` + statustxt;

  
    },
    Reset() {
        this.newContractType = "";
        this.reportUser = "";
        this.st_time = "";
        this.en_time = "";
        this.st_time1 = "",
        this.en_time1 = "",
        this.subRegulatorId = "";
        this.insuranceCompanyId = "";
        this.victimUser = "";
        this.victimPolicyNo = "";
        this.victimNational = "";
        this.subIncidentType = "";
        this.rescueType = "";
        this.miniPolicy = "";
        this.victimMobile = "";
        this.hospitalName = "";
        this.caseNo = "";
        this.jtOrderId = "";
        this.sta = "全部";
      this.getData();
    },
    tostatr(item) {
      console.log(item);
      var obj = {
        token: JSON.parse(window.localStorage.getItem("data")).data,
        caseId: item.caseId,
      };
      usersendCaseMail(obj).then((res) => {
        if (res.data.code == 0) {
          this.$message.success("发送成功");
          this.getData();
        }
        console.log(res);
      });
      console.log(item);
    },
    suoshuFun() {
      userlist_regulator({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.insuranceCompanyId,
      }).then((res) => {
        this.companies1 = res.data.obj;
        console.log(res);
      });
    },
    topar(id,item) {
      console.log()
      // this.$router.push({
      //   path: '/cmd_center/caseDetails',
      //   query: {
      //     caseid: id
      //   },
      // });
      //  this.$router.push({
      //     name:'finishDetails1',
      //     query:{
      //       caseid: id
      //     }
      //   });

      var url = "";
      if (SEVSRS == "http://api.test.dajiuxing.com.cn/") {
        url = "http://www.test.dajiuxing.com.cn/";
      } else {
        url = "https://www.dajiuxing.com.cn/";
      }
      window.open(url + "djxwork/#/cmd_center/createDetails?caseid=" + id +'&subRegulatorIdname=' + item.subRegulatorIdname);
      return;
      let that = this;
      this.$router.push({
        path: "par",
        name: "ComPar",
        params: {
          token: that.token,
          obj: that.obj,
          victimList: that.victimList,
          index,
        },
        query: {
          typeId: this.typeId,
          caseid: this.obj[index].id,
          backto: 0,
        },
      });
    },
    setTxt(str, status) {
      if (constants.setTxt(str, status)) {
        return constants.setTxt(str, status);
      } else {
        return str;
      }
    },
    setTime(str) {
      return constants.time(str);
    },
    handleClick(tab, event) {
      console.log(tab);
    },
    topathDetail(index, item) {
      console.log(item)
      this.itemcaseID = item.caseId;

      this.topathindex = index;
      if (item.insurancePolicyNo == "" || item.insurancePolicyNo == undefined) {
        this.$message.error("保单号不能为空");
        return;
      }
      
      // 直接跳转到启动救援页面，不显示附件列表弹框
      if (this.$route.name == "ComAwait1") {
        this.$router.push({
          name: "helpStart",
          params: {
            token: this.token,
          },
          query: {
            typeId: 800,
            caseid: this.itemcaseID,
            refused: 1,
          },
        });
      } else {
        this.$router.push({
          name: "helpStart",
          params: {
            token: this.token,
          },
          query: {
            typeId: 800,
            caseid: this.itemcaseID,
          },
        });
      }
    },
    listSubUser() {
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        all: 1,
      };
      listSubUser(data)
        .then((res) => {
          console.log(res);
          this.cooperaterData = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelectionChange(val) {
      this.cooperaterDataListCheck = val;
    },
    handleSelectionChange1(val) {
      this.ruserDataListCheck = val;
    },
    removeDomestic(id) {
      var data = {
        token: this.token,
      };
      removeDomestic(data, id)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toUrl(url) {
      window.open(url);
    },
    filt() {
      if(this.insuranceCompanyId == '' || this.insuranceCompanyId == null || this.insuranceCompanyId == undefined) {
        this.subRegulatorId = ''
      }
      this.start = 0;
      this.getData(
        this.st_time,
        this.en_time,
        this.st_time1,
        this.en_time1,
        this.reportUser,
        this.newContractType,
        this.insuranceCompanyId,
        this.subRegulatorId
      );
    },
    sttime() {
      this.st_time = this.st_time * 1;
    },
    entime() {
      this.en_time = this.en_time * 1;
    },
    sttime1() {
      this.st_time1 = this.st_time1 * 1;
    },
    entime1() {
      this.en_time1 = this.en_time1 * 1;
    },
    beginTimer() { //这个计时器是每秒减去数组中指定字段的时间
      let that = this;
      this.ticker = setInterval(() => {
        for (let i = 0, len = that.tableData.length; i < len; i++) {
          const item = that.tableData[i];
          console.log(that.tableData[0].countdown)
            if (that.tableData[0].countdown == false) {
              item.countdown = false
              clearInterval(that.ticker);
            
          }
          if (item.obj.stateText4 && item.obj.stateText4 > 0) {
            item.obj.stateText4 = item.obj.stateText4 - 1000;
          } else {
            item.countdown = false
          }
        }
      }, 1000);
    },
    creatTime(time) { //这个函数是每秒把时间重新计算下
      
      if (time >= 0) {
        let h = Math.floor((time / 1000 / 60 / 60) % 24);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        // return h+'时'+m+'分'+s+'秒';
       
        return m+'分'+s+'秒'
      }
    },
    getData(
      st,
      et,
      st1,
      et1,
      reportUser,
      newContractType,
      insuranceCompanyId,
      subRegulatorId
    ) {
      userlist_regulator({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.insuranceCompanyId,
      }).then((res) => {
        this.companies1 = res.data.obj;
        console.log(res);
      });
      listSubRegulators({
        token: JSON.parse(window.localStorage.getItem("data")).data,
      }).then((res) => {
        this.companies = res.data.obj;
        console.log(res);
      });
      // var status='status=110&status=111&status=113';
      // this.tableData = [];
      let that = this;
      let n = 0;
      let sex = "";
      let isshow = false;
      let stTime = st || this.st_time;
      let enTime = et || this.en_time;
      let stTime1 = st1 || this.st_time1;
      let enTime1 = et1 || this.en_time1;
      let plan = "";
      let list = [];
      let tl = "";
      if (
        stTime ||
        enTime ||
        stTime1 ||
        enTime1 ||
        reportUser ||
        newContractType ||
        insuranceCompanyId ||
        subRegulatorId ||
        this.victimUser ||
        this.victimNational ||
        this.subIncidentType ||
        this.rescueType ||
        this.miniPolicy ||
        this.victimPolicyNo ||
        this.victimMobile ||
        this.hospitalName ||
        this.caseNo|| 
        this.jtOrderId
      ) {
          if(stTime == null) {
        stTime = ''
       }
       if(enTime == '' || enTime == null ) {
        enTime =''
       }else{
        enTime = enTime + 24 * 60 * 60 * 1000 - 1
       }
       if(stTime1 == null) {
        stTime1 = ''
       }
       if(enTime1 == '' || enTime1 == null ) {
        enTime1 =''
       }else{
        enTime1 = enTime1 + 24 * 60 * 60 * 1000 - 1
       }
        tl =
          tl +
          `&incidentStartTs=${stTime}&incidentEndTs=${enTime}&startTs=${stTime1}&endTs=${enTime1}&reportUser=${this.reportUser}&newContractType=${this.newContractType}&regulatorId=${this.insuranceCompanyId}&subRegulatorId=${this.subRegulatorId}&victimUser=${this.victimUser}&victimNational=${this.victimNational}&victimPolicyNo=${this.victimPolicyNo}&reporterContact=${this.victimMobile}&hospitalName=${this.hospitalName}&caseNo=${this.caseNo}&miniPolicy=${this.miniPolicy}&jtOrderId=${this.jtOrderId}&rescueType=${this.rescueType}&subIncidentType=${this.subIncidentType}`;
      }
      let nl = 0;
      var statustxt = "";
      if (this.sta == "全部") {
        statustxt =
          statustxt +
          `&status=180`;
      } else {
        statustxt = this.sta;
      }
      fetch(constants.domain + "rescue/case/list_case", {
        method: "POST",
        body:
          `token=${this.token}&specialState=${this.state}&typeId=${this.$route.query.typeId}&start=${this.start}&count=${this.count}` +
          tl +
          statustxt,
        mode: "cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }).then(function (res) {
          // that.tableData = res.data.obj
          console.log(res);
          return res.json();
        }).then(function (data) {
          that.total = data.total;
          if (data.obj) {
            that.tableData = data.obj
            that.tableData.map((v, i) => {
              console.log(v)
              if (v.victimList[0].obj.gender == "1") {
                v.sex = "男";
              } else if (v.victimList[0].obj.gender == "2") {
                v.sex = "女";
              } else {
                v.sex = "-";
              }
              if (
                v.victimList[0].obj.insurancePolicyNo &&
                v.victimList[0].obj.insurancePolicyNo != ""
              ) {
                v.isshow = true;
              } else {
                v.isshow = false;
              }
              var pt = constants.pt2txt2(v.obj.caseState);
              if (
                v.obj.caseState == 140 ||
                v.obj.caseState == 150 ||
                v.obj.caseState == 160
              ) {
                nl++;
                // getout(v.obj.caseState);
              } 
              if (v.generalLocation) {
                if (!constants.setTxt(v.generalLocation.addr, "zh")) {
                  v.address = v.generalLocation.addr;
                } else {
                  v.address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, "zh") : constants.setTxt(v.generalLocation.addr, "en");
                }
              }
            let d1 = new Date().getTime();
            let d2 = v.obj.reportTs;
            
              // this.$route.params.caseList.obj.reportTs
              // 判断是否超市20分钟
              v.obj.stateText4 = v.obj.reportTs + 1200000 - new Date().getTime()
              if(Math.abs(d1-d2) >= (20*60*1000)) {
                v.countdown = false
              }else {
                v.countdown = true
              }
              console.log(v.helpOrder)
              if(v.helpOrder == null) {
                v.jtOrderId = ''
              }else {
                v.jtOrderId = v.helpOrder.id
              }
              v.state = v.obj.caseState
              v.caseId= v.obj.id
              v.initialCaseId= v.obj.initialCaseId
              v.stateText3= v.obj.stateText3 || "无"
              v.number= i + 1 //序号
              v.casenumber= v.obj.caseNo //案件编号
              v.hospitalName = v.obj.hospitalName
              v.username= v.victimList[0].obj.victimName //用户信息
              v.reportUser= v.victimList[0].obj.victimName //用户信息
              v.papers= v.victimList[0].obj.idNo //身份证号
              v.rescueType = v.obj.rescueType
              v.phone= v.obj.reporterContact //联系方式
              v.time= constants.time(v.obj.incidentTs) //出险时间
              v.reportTs= constants.time(v.obj.reportTs)
              v.subIncidentType = v.obj.subIncidentType
              v.plan= pt.phase //进度
              v.node= pt.node //节点
              v.open= v.obj.caseSrc
              v.get_time= constants.time(v.obj.incidentTs)
              v.op= "查看并操作"
              v.insuranceUrl= v.victimList[0].obj.insurancePaper //用户保险详情链接
              v.w= v.obj.updateAt
              v.subRegulatorIdname= v.obj.subRegulatorId
              v.regulatorId= v.obj.regulatorId
              v.miniPolicy= v.obj.miniPolicy
              v.insurancePolicyNo= v.victimList[0].obj.insurancePolicyNo
              v.newContractType= v.obj.newContractType
              v.creat_time = v.obj.reportTs + 1200000
              for (var j = 0; j < that.companies1.length; j++) {
                if ( v.subRegulatorIdname == that.companies1[j].id) {
                  v.subRegulatorIdname = that.companies1[j].name;
                }
              }
              // console.log(v.obj)
              // console.log(that.tableData)
              that.caseId = v.obj.id;
              that.obj.push(v.obj);
              that.victimList.push(v.victimList[0]);
              // console.log(that.time(v.obj.reportTs))
             
            });
          }
        });
        if (that.ticker) { //这一段是防止进入页面出去后再进来计时器重复启动
          clearInterval(that.ticker);
        }
        that.beginTimer(); //启动计时器减指定字段的时间
    },
    time(reportTs){
      var count = setInterval(function(){
        var nowTime =reportTs + 1200000;
        var time1 =new Date().getTime();
        var dayTimeH = Math.floor((nowTime -time1)/1000/3600)
        if(dayTimeH < 10) {
          dayTimeH="0"+dayTimeH
        }
        var datTimeM=Math.floor((nowTime-time1)/(1000*60)%60)
        if(datTimeM<10) {
          datTimeM="0"+datTimeM
        }
        var dayTimeS=Math.floor((nowTime-time1)/1000%60)
        if(dayTimeS < 10) {
          dayTimeS = "0"+dayTimeS
        }
        return dayTimeH +'时'+ datTimeM+'分' + dayTimeS;
      },1000)
      return count;
    },
  
    // getData() {

    //   var data = {
    //     token: this.token,
    //     typeId: 800
    //   }
    //   xingshiGong(data,status)
    //     .then(res => {
    //       console.log(res);
    //       this.listSubUser()
    //       this.tableData=res.data.obj
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    // },
    closeCase() {
      var data = {
        token: this.token,
        caseId: this.caseId,
      };
      closeCase(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("案件已关闭");
            this.getData();
            this.dialogFormVisible1 = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    listDomestic(id) {
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        caseId: id,
      };
      listDomestic(data)
        .then((res) => {
          this.cooperaterDataList = res.data.obj;
          var cooperaterDataList = [];
          this.cooperaterDataList.forEach((item) => {
            this.cooperaterData.forEach((item1) => {
              if (item1.id == item.id) {
                cooperaterDataList.push(item1);
              }
            });
          });
          this.cooperaterDataList = cooperaterDataList;
          this.toggleSelection(cooperaterDataList);
        })
        .catch((err) => {
          console.log(err);
        });
      var data1 = {
        token: this.token,
        caseId: id,
      };
      listNormalUser(data1)
        .then((res) => {
          console.log(res);
          this.cooperaterData1 = res.data.obj;
          setTimeout(() => {
            this.toggleSelection1(this.cooperaterData1);
          }, 500);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    diffDomestic() {
      var fids = "";
      this.cooperaterDataListCheck.forEach((item, index) => {
        fids += "fids=" + item.id + "&";
      });
      var oids = "";
      this.cooperaterDataList.forEach((item, index) => {
        if (index < this.cooperaterDataList.length - 1) {
          oids += "oids=" + item.id + "&";
        } else {
          oids += "oids=" + item.id;
        }
      });
      var data = {
        token: this.token,
        caseId: this.caseId,
      };
      diffDomestic(data, fids, oids)
        .then((res) => {
          if (res.data.code == 0) {
            this.showcooperaterDialogVisible = false;
            this.$message.success("添加成功");
            this.getData();
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    diffNormalUser() {
      var fids = "";
      this.ruserDataListCheck.forEach((item, index) => {
        if (index < this.ruserDataListCheck.length - 1) {
          fids += "fids=" + item.id + "&";
        } else {
          fids += "fids=" + item.id;
        }
      });
      var data = {
        token: this.token,
        caseId: this.caseId,
      };
      diffNormalUser(data, fids)
        .then((res) => {
          if (res.data.code == 0) {
            this.showcooperaterDialogVisible = false;
            this.$message.success("添加成功");
            this.getData();
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    tores(obj) {
      console.log(obj);
      this.caseId = obj.obj.id;
      this.dialogFormVisible = true;
      // this.totalFee=obj.obj.totalFee ;
      this.medicFee = obj.obj.medicFee || 0;
      this.otherFee = obj.obj.otherFee || 0;
      this.rescueFee = obj.obj.rescueFee || 0;
    },
    sureFun() {
      this.totalFee =
        Number(this.medicFee) + Number(this.otherFee) + Number(this.rescueFee);
      var data = {
        token: this.token,
        id: this.caseId,
        totalFee: this.totalFee,
        medicFee: this.medicFee,
        otherFee: this.otherFee,
        rescueFee: this.rescueFee,
      };
      getfinishSureCase(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.getData();
            this.dialogFormVisible = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleSelection(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    toggleSelection1(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable1.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable1.clearSelection();
      }
    },
    //创建大救星账户
    newDJXid() {
      if (this.victimName == "") {
        return this.$message.error("出险人姓名不能为空");
      } else if (this.nationalMobile == "") {
        return this.$message.error("手机号不能为空");
      }
      var data = {
        token: this.token,
        name: this.victimName,
        nationalMobile: this.nationalMobile,
      };
      creatBasic(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("创建成功");
            this.addContacterDialogVisible = false;
            this.cooperaterData1.push(res.data.obj);
            this.victimName = "";
            this.nationalMobile = "";
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openWork(caseId) {
      joinCoord({ token: this.token, caseId }, "")
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
      this.$store.commit("caseIdFun", caseId);
      this.$store.commit("workBtnFun", true);
    },
  },
  mounted() {
    this.getData();
   
    console.log(this.$route.path);
  },
};
</script>

<style scoped>
/* ========== 优化后的筛选区域样式 ========== */
.filter-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  align-items: end;
}

.filter-item {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1;
}

.filter-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.filter-date-picker,
.filter-input,
.filter-select {
  width: 100%;
}

/* 覆盖Element UI日期选择器的固定宽度 */
.filter-date-picker .el-date-editor.el-input,
.filter-date-picker .el-date-editor.el-input__inner {
  width: 100% !important;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #e4e7ed;
}

.button-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-btn {
  background: #409eff;
  border-color: #409eff;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.filter-btn:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.reset-btn {
  background: #909399;
  border-color: #909399;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.reset-btn:hover {
  background: #a6a9ad;
  border-color: #a6a9ad;
}

.export-btn {
  background: #67c23a;
  border-color: #67c23a;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.export-btn:hover {
  background: #85ce61;
  border-color: #85ce61;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .filter-row {
    gap: 15px;
  }
  
  .filter-item {
    min-width: 180px;
  }
}

@media (max-width: 768px) {
  .filter-container {
    padding: 15px;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .filter-item {
    min-width: auto;
    width: 100%;
  }
  
  .button-row {
    justify-content: center;
  }
  
  .button-group {
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
  
  .filter-btn,
  .reset-btn,
  .export-btn {
    width: 100%;
    max-width: 200px;
  }
}

@media (max-width: 480px) {
  .filter-container {
    padding: 10px;
    margin-bottom: 15px;
  }
  
  .filter-label {
    font-size: 13px;
  }
  
  .filter-btn,
  .reset-btn,
  .export-btn {
    font-size: 14px;
    padding: 8px 16px;
  }
}
/* ========== 优化后的筛选区域样式结束 ========== */

/* 现有样式保持不变 */
.popBox li {
  margin-bottom: 10px;
}
.popBox .el-input {
  width: 300px;
}
.contactAddStyle {
  position: absolute;
  top: 90px;
  right: 20px;
  cursor: pointer;
  z-index: 9;
}
.contactAddStyle::before {
  content: "+";
  color: #00abf9;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 7.5px;
  text-align: center;
  line-height: 15px;
  font-size: 16px;
  margin-right: 5px;
  border: 1px solid #00abf9;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/rescueList2.vue